import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { insertOrUpdateGroup } from '@/api/flow';
import { utilCookies } from '@/util/cookies';
var lang = utilCookies.getLanguage();
var sortData = [{
  label: 'i18n.dd859a5814ac48059b248c9bce03d6ab',
  valueKey: 'name_th',
  maxLength: '40',
  placeholder: 'i18n.303788e0618a4a6fb7177075c6eaceb5'
}, {
  label: 'i18n.00f36898b33540d7897ab2cb411a91fa',
  valueKey: 'name_en',
  maxLength: '40',
  placeholder: 'i18n.0a583ca4f15b4ee686a5ff3895245cf4'
}, {
  label: 'i18n.8edda477ccc448fe81272d9e78d4d919',
  valueKey: 'name_zh',
  maxLength: '8',
  placeholder: 'i18n.6673210d73624c7c95f3500c40777e57'
}];
export default {
  data: function data() {
    return {
      visible: false,
      form: {},
      loading: false,
      rules: {},
      sortData: sortData
      // formComponents: []
    };
  },
  created: function created() {
    // 默认语言必填
    var currentlang = "name_".concat(lang);
    this.rules[currentlang] = [{
      required: true,
      message: this.$t('90')
    }];
    // 默认语言排序优先
    var index = sortData.findIndex(function (item) {
      return item.valueKey === currentlang;
    });
    var firstLangItem = sortData.splice(index, 1)[0];
    sortData.unshift(firstLangItem);
  },
  methods: {
    init: function init(params) {
      this.visible = true;
      if (params.type === 'edit') {
        this.form = params.data;
      }
    },
    // 是否刷新页面
    handleCancel: function handleCancel(isUpdate) {
      this.visible = false;
      this.$emit('update', isUpdate);
    },
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          insertOrUpdateGroup(_this.form).then(function (res) {
            _this.handleCancel(true);
          }).finally(function () {
            return _this.loading = false;
          });
        }
      });
    }
  }
};